/**
 * sessionStorage-only persistence for the OAuth `TokenSet` (Story 013.2 AC5).
 *
 * Mirrors `configStore.ts`'s optional-storage-param convention, but never
 * touches localStorage — the OAuth token is credential-adjacent material.
 */
import type { TokenSet } from '@gl-demo-ultimate-odupre/connect-with-gitlab';

export const TOKEN_SET_SESSION_KEY = 'cwc-oauth-token-set';

export function persistTokenSet(
  tokenSet: TokenSet,
  session: Storage = globalThis.sessionStorage,
): void {
  session.setItem(TOKEN_SET_SESSION_KEY, JSON.stringify(tokenSet));
}

export function readPersistedTokenSet(
  session: Storage = globalThis.sessionStorage,
): TokenSet | null {
  const raw = session.getItem(TOKEN_SET_SESSION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as TokenSet;
  } catch {
    return null;
  }
}

export function clearPersistedTokenSet(
  session: Storage = globalThis.sessionStorage,
): void {
  session.removeItem(TOKEN_SET_SESSION_KEY);
}
